import React,{useState} from 'react'

const ExploreboxAccordian1 = (props) => {

    const[modal,showModal]=useState(false)
    const[modal1,showModal1]=useState(false)
    const[modal2,showModal2]=useState(false)
    const[modal3,showModal3]=useState(false)

    const openModal=(one,two,three,four)=>{
        showModal(one);
        showModal1(two);
        showModal2(three);
        showModal3(four);
    }
    return (
        <>
    
              <div className="events__accordian">
            <div className="events__accordian__content">
                 {/*  */}
                 <div className="tab" onClick={()=>openModal(true,false,false,false)}>
                    <h2>About</h2>
                   {modal &&    <div className="tab_content one1"  >
                    <p> {props.first}</p>
                </div>}
                </div>
                {/*  */}
                <div className="tab" onClick={()=>openModal(false,true,false,false)}>
                    <h2>Timeline</h2>
                   {modal1 &&    <div className="tab_content one"  >
                     <div className="div1">
                         <h3>registration date :</h3>
                         <p>{props.date1}</p>
                     </div>
                     <div className="div1">
                         <h3>submissionresults date :</h3>
                         <p>{props.date2}</p>
                     </div>
                     <div className="div1">
                         <h3>registation date :</h3>
                         <p>{props.date3}</p>
                     </div>
                    
                </div>}
                </div>
                {/*  */}
                <div className="tab" onClick={()=>openModal(false,false,true,false)}>
                    <h2>Rules</h2>
                   {modal2 &&     <div className="tab_content two" >
                        <div className="div1">
                            <h3><span> {props.para1} </span></h3>
                            <h3> <span> {props.para2} </span></h3>
                            <h3> <span> {props.para3} </span></h3>
                            <h3> <span> {props.para4} </span></h3>
                            
                        </div>
                </div>}
                </div>
                {/*  */}
                <div className="tab" onClick={()=>openModal(false,false,false,true)}>
                    <h2>contact us</h2>
                   {modal3 &&    <div className="tab_content three">
                    <h2> {props.person} </h2>
                    <h4> {props.mail} </h4>
                    <p>contact: {props.contact} </p>
                </div>}
                </div>
                {/*  */}
            </div>
        </div>
        </>

    )
}

export default ExploreboxAccordian1
